import React from 'react';

function CustomCard({ image, title, para, onClick }) {
	return (
		<div
			className='manage-account__custom-card px-2 py-3'
			onClick={onClick}
		>
			<div
				style={{ height: '120px' }}
				className='d-flex justify-content-center align-items-center'
			>
				<img src={image} alt={image} className='' />
			</div>

			<h5 className='mt-3 font-weight-bold'>{title}</h5>
			<p>{para}</p>
		</div>
	);
}

export default CustomCard;
